import { SapInventoryResponse } from "integration/generated/customTransactions/data-contracts";
import { LatLng, StoreAttribute, StoreDetails } from "../types/Store";
import { findStoreAttributeByName, findStoreAttributeValueByName, getStoreURL } from "./StoreStock";
import { DayNumberMapping, StoreOpenTimeAttrDayMapping } from "../constants/clickAndCollect";
import { StorelocatorStorelocatorItem } from "integration/generated/transactions/data-contracts";

export const fetchStoreTimeString = (day:number, store:StoreDetails, storeTimingsSpecial:string) => {
    let counter:number=1;
    let storeTimings = "";
    do{
        if(storeTimingsSpecial==="")
            storeTimings+=findStoreAttributeValueByName(store.attributes,StoreOpenTimeAttrDayMapping[day], "displayValue")
        else storeTimings+=storeTimingsSpecial;
        if(storeTimings != "" && !storeTimings.toLowerCase().includes("gesloten")) {
            break;
        } else {
            counter++;
            day++;
            if(day > 7){
                day = 1;
            }
        }
    }while(storeTimings != "" && counter <= 7);
    return storeTimings.toLowerCase().includes("gesloten")?"":storeTimings;
}

export const filterStoresWithStockAvailability = (
            stores:StoreDetails[], storeInv:SapInventoryResponse[], 
            showCCStoreCount:number, allowStorePickForOOSItems:string,
            showNearStoresCount?:number
    ) => {
        let tempStores = [...stores];
        tempStores.length = showNearStoresCount??showCCStoreCount;
        tempStores = tempStores.filter((store=>{
            const invObj = storeInv.find(inv=>inv.storeNumber===store.physicalStoreName);
            const isAvailable = invObj && invObj.available!=='OutOfStock' && invObj.available !== 'CallStoreStock';
            return isAvailable || (!isAvailable && allowStorePickForOOSItems==="true")
        }))?.filter(Boolean);
        if(tempStores.length>showCCStoreCount)tempStores.length = showCCStoreCount;
        return tempStores;
}

export const createDisplayStoreDetails = (ps:StorelocatorStorelocatorItem, storeLocatorRoute?:string) => {
    if(!ps)return {} as StoreDetails;
    let store = {
        id: ps.uniqueID,
        storeName: ps.Description?.at(0)?.displayStoreName,
        physicalStoreName: ps.storeName??"",
        storeFullAddress: `${ps.addressLine?.at(0)} ${ps.addressLine?.at(1)} `,
        postalCode: `${ps.postalCode}`,
        phone: ps.telephone1??"",
        coordinates: {
            lng: Number(ps.longitude?.trim()),
            lat: Number(ps.latitude?.trim()),
        } as LatLng,
        distance: ps?.distance??"",
        attributes: ps.Attribute ?? [],
        city: ps.city??"",
        state: ps.stateOrProvinceName??"",
        displayAddress: `${ps.addressLine?.at(0)}, ${ps.addressLine?.at(1)} ${ps.addressLine?.at(2) !== "Migrate Data By ES" ? ps.addressLine?.at(2) : ""}`,
    } as StoreDetails;
    store.storePageURL = storeLocatorRoute ?getStoreURL(store, storeLocatorRoute):'';
    return store;
}

// for Performance . Minimal data for stloc home page 

export const createBasicStoreDetails = (ps:StorelocatorStorelocatorItem, storeLocatorRoute?:string) => {
    if(!ps)return {} as StoreDetails;
    let store = {
        storeName: ps.Description?.at(0)?.displayStoreName,
        storeFullAddress: `${ps.addressLine?.at(0)} ${ps.addressLine?.at(1)} `,
        postalCode: `${ps.postalCode}`,
        city: ps.city??"",
        coordinates: {
            lng: Number(ps.longitude?.trim()),
            lat: Number(ps.latitude?.trim()),
        } as LatLng,
    } as StoreDetails;
    store.storePageURL = storeLocatorRoute ?getStoreURLFast(ps.Attribute as StoreAttribute[], storeLocatorRoute):'';
    return store;
}

export const getStoreURLFast = (storeAttr:StoreAttribute[], storeLocatorRoute:string) => {
    const city:string = findStoreAttributeByName(storeAttr,"seotokencity")?.value??"";
    const street:string = findStoreAttributeByName(storeAttr,"seotokenstreet")?.value??"";
    return city && street ? storeLocatorRoute+`/${city}`+`/${street}` : storeLocatorRoute;
}

export const getCityURLFast = (storeAttr:StoreAttribute[], storeLocatorRoute:string) => {
    const city:string = findStoreAttributeByName(storeAttr,"seotokencity")?.value??"";
    return city ? storeLocatorRoute+`/${city}`: storeLocatorRoute;
}